import {
  GET_PROFILE_TEACHER,
  GET_PROFILE_TEACHER_ERROR,
  PROFILE_TEACHER_ERROR,
  CLEAR_PROFILE_TEACHER,
  UPDATE_PROFILE_TEACHER,
  GET_PROFILE_TEACHER_BY_ID_SUCCESS,
  GET_PROFILE_TEACHER_BY_ID_ERROR,
  BOOK_TIME_SUCCESS,
  SET_LOADING_TRUE,
  FETCH_ALL_TEACHERS,
  FETCH_TEACHERS_BY_SEARCH,
  FETCH_TEACHERS_BY_SEARCH_FAIL,
  START_LOADING,
  END_LOADING,
  SET_UPLOADING_TRUE,
  SET_UPLOADING_FALSE
} from '../actions/types'

const initialState = {
  profileTeachers: [],
  profileTeacher: null,
  loading: true,
  error: {},
  currentPage: 1,
  numberOfPages: 1,
  uploading: false
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case END_LOADING:
      return {
        ...state,
        loading: false
      }
    case FETCH_ALL_TEACHERS:
      return {
        ...state,
        profileTeachers: payload.data,
        currentPage: payload.currentPage,
        numberOfPages: payload.numberOfPages
      }
    case FETCH_TEACHERS_BY_SEARCH:
      return {
        ...state,
        profileTeachers: payload.data
      }
    case FETCH_TEACHERS_BY_SEARCH_FAIL:
      return {
        ...state,
        profileTeachers: [],
        error: payload
      }
    case SET_LOADING_TRUE:
      return {
        ...state,
        loading: true,
      }
    case GET_PROFILE_TEACHER:
    case UPDATE_PROFILE_TEACHER:
    case GET_PROFILE_TEACHER_BY_ID_SUCCESS:
      return {
        ...state,
        profileTeacher: payload,
        loading: false,
      }
    case BOOK_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
        profileTeacher: payload.newProfileTeacher,
      }
    case PROFILE_TEACHER_ERROR:
    case GET_PROFILE_TEACHER_BY_ID_ERROR:
    case GET_PROFILE_TEACHER_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
        profileTeacher: null,
      }
    case CLEAR_PROFILE_TEACHER:
      return {
        ...state,
        profileTeacher: null,
      }
    case SET_UPLOADING_TRUE:
      return {
        ...state,
        uploading: true
      }
    case SET_UPLOADING_FALSE:
      return {
        ...state,
        uploading: false
      }
    default:
      return state
  }
}
